import BossDialog from "../../components/BossDialog";
import * as API from "../../framework/API/api"
import ActionButton from "../../framework/forms/helpercomponents/buttons/ActionButton";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { useEffect, useState } from "react";
import "./RecursiveTemplatePopup.css";
import { CustomTemplateType, ENTITYNAME, TOAST_TYPES } from "../../framework/constant/constant";
import ToastNotification from "../../components/ToastNotification";
import { useTranslation } from "../../locale/useTranslation";

const RecursiveTemplatePopup = ({ forLoad, data, onClose, onRecursiveTemplateSelect }) => {

    const lang = useTranslation();
    const [templates, setTemplates] = useState([]);
    const [selectedTemplate, setSelectedTemplate] = useState(null);
    const [name, setName] = useState("");
    const [isDeleting, setIsDeleting] = useState(false);

    useEffect(() => {
        if (forLoad) {
            loadTempalteData();
        }
    }, [])

    const loadTempalteData = async () => {
        try {
            let res = await API.getData(ENTITYNAME.CustomTemplate, { query: ['type', '=', CustomTemplateType.RepeatPattern] });
            if (res.success) {
                setTemplates(res.data);
                if (res.data?.length > 0) {
                    setSelectedTemplate(res.data[0]);
                } else {
                }
            } else {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Failed to load templates" });
            }
        } catch (error) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Failed to load templates" });
        }
    }

    const onSaveTemplate = async () => {
        if (!name.trim()) {
            ToastNotification({ type: TOAST_TYPES.WARNING, title: lang.warning_message_title, message: "Template name is required" });
            return;
        }
        try {
            let res = await API.saveData(ENTITYNAME.CustomTemplate, { name: name.trim(), data: data, type: CustomTemplateType.RepeatPattern });
            if (res.success) {
                ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: "Template saved successfully" });
                onClose();
            } else {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Failed to save template" });
            }
        } catch (error) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Failed to save template" });
        }
    }

    const onDeleteTemplate = async () => {
        if (!selectedTemplate?._id || isDeleting) {
            return;
        }

        setIsDeleting(true);
        try {
            const res = await API.deleteData(ENTITYNAME.CustomTemplate, selectedTemplate._id, "_id");
            if (res?.success) {
                const updatedTemplates = templates.filter((item) => item?._id !== selectedTemplate._id);
                setTemplates(updatedTemplates);
                setSelectedTemplate(updatedTemplates.length > 0 ? updatedTemplates[0] : null);
                ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: "Template deleted successfully" });
            } else {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Failed to delete template" });
            }
        } catch (error) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Failed to delete template" });
        } finally {
            setIsDeleting(false);
        }
    }

    const hasTemplates = templates?.length > 0;

    return <BossDialog title={forLoad ? "Load from Template" : "Save as Template"} onClose={onClose} width={"460px"} >
        <div className="recursive-template-popup">
            <div className="recursive-template-popup__intro">
                <h4 className="recursive-template-popup__heading">
                    {forLoad ? "Use an existing template" : "Create a reusable template"}
                </h4>
                <p className="recursive-template-popup__subheading">
                    {forLoad
                        ? "Select a template and apply it to the current recurrence setup."
                        : "Save the current recurrence configuration to reuse it later."}
                </p>
            </div>

            {forLoad ? (
                <>
                    <div className="recursive-template-popup__field-row">
                        <label className="recursive-template-popup__label">Select Template</label>
                        {hasTemplates && (
                            <span className="recursive-template-popup__count">{templates.length} available</span>
                        )}
                    </div>
                    <div className="recursive-template-popup__selection-row">
                        <DropDownList
                            data={templates}
                            style={{ width: "100%" }}
                            value={selectedTemplate}
                            onChange={(e) => setSelectedTemplate(e.target.value)}
                            textField="name"
                            dataItemKey="_id"
                        />
                        <button
                            type="button"
                            className="recursive-template-popup__delete-btn"
                            title="Delete selected template"
                            onClick={onDeleteTemplate}
                            disabled={!selectedTemplate || isDeleting}
                        >
                            <i className={`fa ${isDeleting ? "fa-spinner fa-spin" : "fa-trash"}`}></i>
                        </button>
                    </div>
                    {!hasTemplates && (
                        <div className="recursive-template-popup__empty-state">
                            No templates found. Save one first, then come back to load it.
                        </div>
                    )}
                    <div className="recursive-template-popup__actions">
                        <ActionButton name="Cancel" btnColor="danger" onClick={onClose} />
                        <ActionButton
                            name="Set Template"
                            disabled={!selectedTemplate}
                            onClick={() => onRecursiveTemplateSelect(selectedTemplate)}
                        />
                    </div>
                </>
            ) : (
                <>
                    <label className="recursive-template-popup__label">Template Name</label>
                    <input
                        className="recursive-template-popup__input"
                        type="text"
                        value={name}
                        maxLength={80}
                        placeholder="e.g. Prime Time Weekday Rotation"
                        onChange={(e) => setName(e.target.value)}
                    />
                    <div className="recursive-template-popup__hint">Choose a short, descriptive name.</div>
                    <div className="recursive-template-popup__actions">
                        <ActionButton name="Cancel" btnColor="danger" onClick={onClose} />
                        <ActionButton name="Save Template" disabled={!name.trim()} onClick={onSaveTemplate} />
                    </div>
                </>
            )}
        </div>
    </BossDialog>
}

export default RecursiveTemplatePopup;